import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthNotGuard } from './core/guards/auth-not.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layout/admin/layout/layout.component';

const routes: Routes = [
  // Rota padrão redireciona para login
  
  // Rotas de autenticação (públicas)
  {
    path: 'auth',
    canActivate: [AuthNotGuard],
    loadChildren: () => import('./auth/authentication.module').then(m => m.AuthenticationModule)
  },
  
  // Rotas protegidas (área logada)
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
      },
      { 
        path: 'dashboard', 
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule) 
      },
      { 
        path: 'sales', 
        loadChildren: () => import('./modules/sales/sales.module').then(m => m.SalesModule) 
      },
      {
        path: 'monitoring',
        loadChildren: () => import('./modules/monitoring/monitoring.module').then(m => m.MonitoringModule)
      },
      { 
        path: 'payment', 
        loadChildren: () => import('./modules/payment/payment.module').then(m => m.PaymentsModule) 
      },
      { 
        path: 'registrations', 
        loadChildren: () => import('./modules/registrations/registrations.module').then(m => m.RegistrationsModule) 
      },
      { 
        path: 'coupons', 
        loadChildren: () => import('./modules/coupons/coupons.module').then(m => m.CouponsModule) 
      },
      { 
        path: 'wallet', 
        loadChildren: () => import('./modules/wallet/wallet.module').then(m => m.WalletModule) 
      },
      { 
        path: 'marketplace-config', 
        loadChildren: () => import('./modules/marketplace-config/marketplace-config.module').then(m => m.MarketplaceConfigModule) 
      },
      {
        path: 'user-feedback',
        loadChildren: () => import('./modules/user-feedback/user-feedback.module').then(m => m.UserFeedbackModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./modules/notification/notification.module').then(m => m.NotificationModule)
      },
      {
        path: 'invoice',
        loadChildren: () => import('./modules/invoice/invoice.module').then(m => m.InvoiceModule)
      },
      {
        path: 'audit',
        loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule)
      },
      {
        path: 'system-info',
        loadChildren: () => import('./modules/system-info/system-info.module').then(m => m.SystemInfoModule)
      },
      // A tela inicial é a fila de trabalho; métricas ficam em /dashboard.
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  
  // Rota para página não encontrada
  { path: '**', redirectTo: '/auth/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }